module.exports = __webpack_public_path__ + "static/img/Frame603.79815533.png";